<template>
  <div class="header" :style="{ color, backgroundColor: bgColor }">
    <div v-if="showBackButton" @click="goBack" class="back-btn">
      <img src="@/assets/img/header-back-btn.png" />
    </div>
    <div v-if="showLogOut" @click="logOut" class="back-btn">Keluar</div>

    <div class="header_title">{{ title }}</div>
    <div
      v-if="showCustomerService"
      class="right-block kefu"
      @click="showCustomerServiceModal"
    >
      Customer Service
    </div>
    <div
      v-if="showRegister && isIOS"
      @click="goRegister"
      class="right-block right-Register"
    >
      Daftar
    </div>

    <van-dialog
      v-model="visible"
      :showConfirmButton="false"
      close-on-click-overlay
    >
      <div class="customer-service-body">
        <p class="title">Customer Service</p>
        <img src="@/assets/img/kefu.png" alt="" />
        <span class="text">modaluang@outlook.com</span>
        <button type="button" class="confirm-btn" @click="onCloseDialog()">
          Dapat
        </button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import dialogVisible from '@/mixins/dialogVisible'
import store from '@/store'
import router from '@/router'
import Cookies from 'js-cookie'
import { isIOS } from '@/utils/detect'

export default {
  name: 'BaseHeaderBar',
  mixins: [dialogVisible],
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  props: {
    title: {
      type: String,
      default: 'Modal Uang'
    },
    showCustomerService: {
      type: Boolean,
      default: true
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showLogOut: {
      type: Boolean,
      default: false
    },
    showRegister: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    bgColor: {
      type: String
    }
  },
  data () {
    return {
      isIOS
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    showCustomerServiceModal () {
      this.visible = true
    },
    // 退出登录
    logOut () {
      store.commit('recordInfo', {
        type: 'userInfo',
        value: {}
      })
      Cookies.remove('userInfo')
      router.push({
        path: '/login'
      })
    },
    // 注册
    goRegister () {
      const { query } = this.$route
      this.$router.push({
        path: '/register',
        query
      })
    }
  }
}
</script>

<style scoped lang="less">
.header {
  position: relative;
  width: 100%;
  height: 100px;
  color: #000;
  text-align: center;
  z-index: 3;
  font-weight: 600;
  font-size: 38px;
  .header_title {
    line-height: 100px;
  }
}

.back-btn {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 30px;
  cursor: pointer;
  font-weight: 500;
  font-size: 28px;
  color: #000;
  img {
    width: 21px;
    height: 34px;
  }
}

.right-block {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-weight: 500;
  font-size: 28px;
  color: #000;
}
.right-Register {
  font-weight: 600;
  font-size: 34px;
}
.kefu {
  margin-right: 20px;
}
.customer-service-title {
  position: relative;

  p {
    .dialog-title;
  }

  .close-icon {
    position: absolute;
    top: 50%;
    right: 32px;
    width: 24px;
    height: 24px;
    transform: translateY(-50%);
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.customer-service-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 25px 54px;
  height: 600px;
  img {
    width: 254px;
    height: 219px;
    margin-top: 70px;
  }
  p {
    margin: 0;
  }
  .title {
    color: #000;
    font-size: 40px;
    font-weight: 600;
    margin-top: 20px;
  }
  .Email,
  .text {
    margin-bottom: 30px;
    font-weight: 500;
    font-size: 34px;
    color: #000;
    margin-top: 40px;
    display: inline-block;
  }
  .confirm-btn {
    .submit-btn;
  }
}
</style>
